// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Baa-z","subtitle":"Caa-z","wrapper":"Daa-z","leftArrow":"Eaa-z","rightArrow":"Faa-z"};